module.exports = __webpack_public_path__ + "static/media/20171212-_DSC2071_Small.d1d7e3ec.jpg";